export default "__VITE_ASSET__7FnIlGMv__"